import { Checkbox } from "@/components/search/search/filters/Checkbox";
import { Collapse } from "@/components/search/search/filters/Collapse";
import { useStore } from "@nanostores/react";
import type { Dispatch, SetStateAction } from "react";
import type { PageTags } from "../../_utils/getPageTags";
import { MultiSelect } from "./MultiSelect";
import { drawerTypeTagsStore } from "./store";
import { useUpdateSearchParams } from "./useUpdateSearchParams";

type Props = {
  allTags: PageTags;
  selectedTags: Array<string>;
  localTags: Array<string>;
  setLocalTags: Dispatch<SetStateAction<Array<string>>>;
  category: "Thème" | "Époque" | "Pays";
  isDesktop?: boolean;
  baseUrl: "/articles/conferencier/" | "/articles/actualite/";
};
export const Tags = ({
  allTags,
  selectedTags,
  localTags,
  setLocalTags,
  category,
  isDesktop = false,
  baseUrl,
}: Props) => {
  const { updateSearchParams } = useUpdateSearchParams(baseUrl);
  const state = useStore(drawerTypeTagsStore);

  const handleChange = (newValue: string, directUpdate = false) => {
    let newTags: Array<string> = [];
    if (localTags.some((lt) => lt === newValue)) {
      newTags = localTags.filter((lt) => lt !== newValue);
    } else {
      newTags = [...localTags, newValue];
    }

    setLocalTags(newTags);

    if (directUpdate) {
      updateSearchParams({
        tags: newTags,
        page: undefined,
      });
    }
  };

  const handleOpen = () => {
    drawerTypeTagsStore.set(state === category ? null : category);
  };

  const handleClickOutside = () => {
    drawerTypeTagsStore.set(null);
  };

  const handleValidate = () => {
    updateSearchParams({
      tags: localTags,
      page: undefined,
    });
  };

  const handleClear = () => {
    updateSearchParams({
      tags: [],
      page: undefined,
    });
  };

  const selectedValuesForCategory = allTags.filter(
    (v) => v.category === category && localTags.includes(v.callbackValue),
  );

  return isDesktop ? (
    <MultiSelect
      placeholder={category}
      onChange={handleChange}
      onValidate={handleValidate}
      onClear={handleClear}
      localValues={localTags}
      selectedValues={selectedTags}
      values={allTags}
      large
      category={category}
    />
  ) : (
    <Collapse
      open={state === category}
      title={category}
      onclick={handleOpen}
      onClickOutside={handleClickOutside}
      count={selectedValuesForCategory.length}
    >
      <div className="mt-5 grid sm:grid-cols-2 gap-[10px]">
        {allTags
          .sort((a, b) => a.title.localeCompare(b.title))
          .map((tag) => (
            <Checkbox
              key={tag.callbackValue}
              label={tag.title}
              checked={localTags.some((lt) => lt === tag.callbackValue)}
              onChange={() => handleChange(tag.callbackValue)}
            />
          ))}
      </div>
    </Collapse>
  );
};
